module.exports = __webpack_public_path__ + "img/22.cfafe0b8.png";